import React from 'react';
import './style.css';

export const LoaderFixed: React.FC = () => (
	<div className="_fixed _inset-0 _z-50 _flex _items-center _justify-center">
		<Loader />
	</div>
);

export const Loader: React.FC<{
	size?: number;
	color?: string;
	margin?: string;
}> = ({ size = 80, color = '#00F181', margin = '0' }) => (
	<div
		style={{
			display: 'inline-block',
			position: 'relative',
			width: size,
			height: size,
			margin,
		}}
	>
		{[0, 1, 2, 3].map((i) => (
			<div
				key={i}
				style={{
					boxSizing: 'border-box',
					display: 'block',
					position: 'absolute',
					width: size,
					height: size,
					border: `${size * 0.08}px solid ${color}`,
					borderRadius: '50%',
					animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
					borderColor: `${color} transparent transparent transparent`,
					animationDelay: `${i * -0.15}s`,
				}}
			/>
		))}
	</div>
);
export default Loader;
